import type { IShape } from '../shapes/interfaces/IShape';

export class MoveShape {
    private readonly shape: IShape;
    private readonly oldX: number;
    private readonly oldY: number;
    private readonly newX: number;
    private readonly newY: number;

    constructor(shape: IShape, oldX: number, oldY: number, newX: number, newY: number) {
        this.shape = shape;
        this.oldX = oldX;
        this.oldY = oldY;
        this.newX = newX;
        this.newY = newY;
    }

    execute(): void {
        this.shape.position(this.newX, this.newY);
    }

    undo(): void {
        this.shape.position(this.oldX, this.oldY);
    }
}
